/* eslint-disable import/prefer-default-export */
import styled from "styled-components";

type BadgeProps = {
  primary?: boolean;
  secondary?: boolean;
  tertiary?: boolean;
};

export const StyledBadge = styled.span<BadgeProps>`
  background-color: ${({ theme }) => theme.colors.white};
  background-color: ${({ primary, theme }) => primary && theme.colors.primary};
  color: ${({ theme }) => theme.colors.primary};
  color: ${({ theme, primary }) => primary && theme.colors.white};
  color: ${({ theme, secondary }) => secondary && theme.colors.primary};
  color: ${({ theme, tertiary }) => tertiary && theme.colors.grey};
  border-radius: ${({ theme }) => theme.borderRadius};
  margin-left: ${({ theme }) => theme.spacing.s};
  padding: ${({ theme }) => `0 ${theme.spacing.s}`};
  height: 16px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  text-transform: uppercase;
  white-space: nowrap;
  letter-spacing: 0.05em;
  font-family: sans-serif;
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  font-size: ${({ theme }) => theme.fontSize.xSmall.desktop};
  border: ${({ theme }) => `1px solid ${theme.colors.primary}`};
  border: ${({ theme, primary }) =>
    primary && `1px solid ${theme.colors.primary}`};
  border: ${({ theme, secondary }) =>
    secondary && `1px solid ${theme.colors.primary}`};
  border: ${({ theme, tertiary }) =>
    tertiary && `1px solid ${theme.colors.grey}`};
`;

StyledBadge.displayName = "StyledBadge";
